<div class="conditional-value-view">
  @if (rangeOperators.includes(surveyConditionalsService.conditionFormValues$().operator)) {
    <empathy-selected-range-view [values]="surveyConditionalsService.conditionFormValues$().valueToMatch"> </empathy-selected-range-view>
  } @else {
    @for (valueToMatch of surveyConditionalsService.conditionFormValues$().valueToMatch; track valueToMatch; let index = $index) {
      @if (choiceQuestionTypes.includes(this.surveyConditionalsService.questionSelected$().type)) {
        <empathy-selected-value-view (onClear)="clearValues.emit(index)">
          <div class="eiq-id-badge" slot="badge">
            <span>{{ valueToMatch }}</span>
          </div>
          <ng-container slot="text">{{ valueToMatch | optionValueOrText: surveyConditionalsService.questionSelected$() | toPlainText }}</ng-container>
        </empathy-selected-value-view>
      } @else {
        <empathy-selected-value-view (onClear)="clearValues.emit(index)">
          <ng-container slot="title">{{ valueToMatch | optionValueOrText: surveyConditionalsService.questionSelected$() | toPlainText }}</ng-container>
        </empathy-selected-value-view>
      }
    }
  }
</div>
